//整数
export function isNum(data) {
	if (isNaN(data)){
		//非数值
		return false
	}else return String(data).indexOf('.') <= -1;
}
//纯中文
export function isChinese(str) {
	let reg = new RegExp("^[\u4e00-\u9fa5]+$");
	return reg.test(str);
}
//汉字和字母
export function chineseAndChar(str) {
	let reg = new RegExp(/^([\u4E00-\u9FA5]|[A-Za-z])+$/);
	return reg.test(str);
}
//校验身份证格式
export function isIdCard(str){
	let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
	return reg.test(str);
}
//取身份证年龄
export function getAgeByIdCard(idCard){
	if (idCard.length < 18){
		return 0;
	}
	//获取出生年月日
	let yearBirth =Number(idCard.substring(6,10)) ;
	let monthBirth =Number(idCard.substring(10,12)) ;
	let dayBirth = Number(idCard.substring(12,14)) ;
	//获取当前年月日并计算年龄
	let myDate = new Date();
	let monthNow = myDate.getMonth() + 1;
	let dayNow = myDate.getDate();
	let age = myDate.getFullYear() - yearBirth;

	if(monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)){
		age--;
	}
	//得到年龄
	return age;
}
//数字和字母
export function onlyNumAndChar(str){
	let reg = new RegExp(/^[0-9A-Za-z]+$/);
	return reg.test(str);
}
//车牌号校验
export function isVehicleNo(value){
	let reg1 = new RegExp(/^[\u4e00-\u9fa5]([\u4E00-\u9FA5]|[A-Za-z0-9]){6}$/);
	let reg2 = new RegExp(/^[\u4e00-\u9fa5]([\u4E00-\u9FA5]|[A-Za-z0-9]){7}$/);
	return reg1.test(value) || reg2.test(value);
}
export function isPhoneNum(str) {
    //要求11位数字
    // let reg = /(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/;
    let reg = /^1[3456789]\d{9}$/;
    return reg.test(str)
}